import * as React from 'react';
import { ArticleCard } from './ArticleCard';
import { Carousel, type DeviceSettingType, useCarousel, useVisibleCount } from 'webapp/components/Carousel';
import { isSvenssons } from 'webapp/theme';
import { useTheme } from '@glitz/react';

type PropType = {
  articles: NordicNest.Api.ArticleListItemApiModel[];
  cardBackgroundColor: string;
  id?: string;
};

const visibleCount: DeviceSettingType = { mobile: 1, tablet: 2, desktop: 2 };

export default function ArticleListCarousel(props: PropType) {
  const carousel = useCarousel(props.id);
  const theme = useTheme()!;

  const nextSlideFactor: DeviceSettingType = React.useMemo(
    () => ({
      mobile: isSvenssons ? 2.2 : 1.5,
      tablet: isSvenssons ? 2.2 : 1.5,
      desktop: isSvenssons ? 2.2 : 1.5,
    }),
    [isSvenssons],
  );

  return (
    <Carousel
      visibleCount={visibleCount}
      gap={isSvenssons ? theme.sharedSpacing.m : theme.spacing.l}
      showNextSlideFactor={nextSlideFactor}
      {...carousel}
    >
      {props.articles?.map(article => (
        <ArticleCard key={article.url} {...article} backgroundColor={props.cardBackgroundColor} />
      ))}
    </Carousel>
  );
}
